import { CHECKOUT_PUBLIC_KEY, EXTERNAL_CHECKOUT_DEV_LIBRARY_PATH, EXTERNAL_CHECKOUT_PROD_JS_LIBRARY_PATH } from '../const';

class CheckoutRisk {
    constructor() {
        this.script = null;
        this.risk = null;
    }

    init() {
        this.addListener();
    }

    initRisk() {
        this.risk = window.Risk.init(CHECKOUT_PUBLIC_KEY);
    }

    createSrc() {
        const head = document.getElementsByTagName('HEAD')[0];
        const link = document.createElement('script');
        const regex = /pk_sbox_/gi;
        const isSandbox = regex.test(CHECKOUT_PUBLIC_KEY);
        const externalLibPath = isSandbox ? EXTERNAL_CHECKOUT_DEV_LIBRARY_PATH : EXTERNAL_CHECKOUT_PROD_JS_LIBRARY_PATH;
        link.async = true;
        link.src = externalLibPath;
        head.appendChild(link);
        this.script = link;
    }

    addListener() {
        this.createSrc();
        this.script.addEventListener('load', () => {
            this.initRisk();
        });
    }

    removeListener() {
        this.script.removeEventListener('load', () => {
            this.initRisk();
        });
    }

    async getDeviceSessionId() {
        let deviceSessionId = null;
        try {
            deviceSessionId = await this.risk.publishRiskData();
        } catch (e) {
            console.error(e);
        }
        return deviceSessionId;
    }
}

export default new CheckoutRisk();
